var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSavioDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.2 31.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #003382;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.8,18.2c1.2,3.9,4.2,7,8,8.4l.6.2V4L1.8,18s0,.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,4.6l-.6-.2v22.8l8.6-14v-.2c-1.2-3.9-4.2-7-8-8.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.5,20c0,4.7-3.9,7.4-9.2,7.4s-9.3-2.5-10.1-7.7h5.7c.4,2.2,2,3.5,4.4,3.5s3.7-1,3.7-2.6c0-5.1-13.5-1.2-13.5-10.2s3.2-6.9,8.8-6.9,8.8,2.2,9.5,7.5h-5.7c-.5-2.2-1.8-3.3-4-3.3s-3.1.9-3.1,2.2c0,4.9,13.4.7,13.4,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.3,22.6h-9l-1.5,4.3h-5.4l8.3-22.8h6.4l8.4,22.8h-5.7l-1.5-4.3ZM57.8,18.5h6l-2.3-6.6-.7-2.6-.7,2.6-2.3,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,19l.7,2.7.7-2.7,5.3-15h5.4l-8.4,22.8h-6.3l-8.4-22.8h5.7l5.3,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95,4h5.4v22.8h-5.4V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.6,15.5c0-7.4,4.4-12,11.4-12s11.4,4.6,11.4,12-4.4,11.9-11.4,11.9-11.4-4.6-11.4-11.9ZM120.9,15.5c0-4.7-2.2-7.6-5.9-7.6s-5.9,2.9-5.9,7.6,2.2,7.5,5.9,7.5,5.9-2.8,5.9-7.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSavioDark);
export default __webpack_public_path__ + "static/media/logo_savio_dark.c4e3b744f483e56425c17a7b1934b035.svg";
export { ForwardRef as ReactComponent };